import Nav from "./../Page/Share/Nav/Nav";
const Post12 = () => {
  return (
    <div>
      <div className="container">
        <Nav></Nav>

        <div className="infowork">
          {/* items Title} */}
          <h2>
            Diamonery Brand Identity Design
          </h2>
          {/* items?.Description */}
          <p>

          </p>
          {/* img section */}
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/5b97ce118185567.61feccbe83d9b.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/4cab3d118185567.61feca019548b.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/421536118185567.62409170d3095.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/21d0d3118185567.61feca0196eb6.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/30758a118185567.61feca0197c68.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/8821be118185567.623857ce99e38.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/924133118185567.61feca0194bb6.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/64e029118185567.623857ce996e4.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/346c39118185567.61feca019a0da.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/1c1235118185567.623857ce9a36d.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/be51b4118185567.61fed164b41bc.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/be2751118185567.61feca01998d9.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/841868118185567.61fed164b3745.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/19dd9c118185567.624b55f214887.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/c74bfb118185567.61feca01942a6.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/bce5f8118185567.61feca0198845.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/102a8b118185567.61feca019a8b1.jpg" alt="" />
          <p>

          </p>
        </div>
      </div>
    </div>
  );
};

export default Post12;
